import { render, staticRenderFns } from "./ConfirmReturn.vue?vue&type=template&id=ac078680&scoped=true"
import script from "./ConfirmReturn.vue?vue&type=script&lang=js"
export * from "./ConfirmReturn.vue?vue&type=script&lang=js"
import style0 from "./ConfirmReturn.vue?vue&type=style&index=0&id=ac078680&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac078680",
  null
  
)

export default component.exports